<template>
  <div class="borrower-archive-container">
    <div class="route-name">{{ $t(`message.sideMenu.${this.$route.name}`) }}</div>
    <div class="active-offers-container loans-container">
      <div class="active-offers-title">
        {{ $t('message.profile.borrower.activeOffers.title') }}
      </div>
      <div class="filters-block" @keyup.enter="setLoansFilter()">
        <div class="filter-block">
          <base-select
            :key="loansFilterSelectKey"
            :placeholder="$t('message.profile.lender.loans.filter.status')"
            :default-value="loansFilterStatus"
            :dictionary-path="'message.profile.lender.loans.archiveFilterStatus.list.'"
            :options-list="['canceled', 'repaid']"
            v-model="loansFilterStatus"
          />
        </div>
        <div class="filter-block">
          <input
            type="text"
            class="filter-input"
            v-model="loansFilter.full_name_lender"
            :placeholder="$t('message.profile.borrower.activeOffers.items.name')"
          >
        </div>
        <div class="datepicker-block">
          <base-datepicker
            v-model="loansFilter.receipt_date"
            :default-value="loansFilter.receipt_date"
            :format="'DD.MM.YYYY'"
            :range="true"
            :placeholder="$t('message.profile.lender.loans.filter.issued')"
          />
        </div>
        <div class="button-block">
          <base-button
            :text="$t('message.profile.lender.loans.filter.apply')"
            :min-height="'36px'"
            @click="setLoansFilter()"
          />
        </div>
        <div class="button-block">
          <base-button
            class="reset-filter-btn"
            :text="$t('message.profile.lender.loans.filter.reset')"
            :min-height="'36px'"
            @click="resetLoansFilter()"
          />
        </div>
      </div>
      <div class="loans-desktop-container">
        <table class="borrower-loans-table">
          <thead>
            <tr class="offers-item-header">
              <th class="agreement" scope="col">№ договора</th>
              <th class="name" scope="col">{{ $t('message.profile.borrower.activeOffers.items.name') }}</th>
              <th class="issued" scope="col">{{ $t('message.profile.borrower.activeOffers.items.issued') }}</th>
              <th class="amount" scope="col">{{ $t('message.profile.borrower.activeOffers.items.amount') }}</th>
              <th class="term" scope="col">{{ $t('message.profile.borrower.activeOffers.items.term') }}</th>
              <th class="percent" scope="col">{{ $t('message.profile.borrower.activeOffers.items.percent') }}</th>
              <th class="income" scope="col">{{ $t('message.profile.borrower.activeOffers.items.income') }}</th>
              <th class="issued-by" scope="col">{{ $t('message.profile.borrower.activeOffers.items.issuedBy') }}</th>
              <th class="peni" scope="col">{{ $t('message.profile.borrower.activeOffers.items.peni') }}</th>
              <th class="total-amount" scope="col">{{ $t('message.profile.borrower.activeOffers.items.totalAmount') }}</th>
              <th class="status" scope="col">{{ $t('message.profile.borrower.activeOffers.items.status') }}</th>
              <th class="pay" scope="col"></th>
            </tr>
          </thead>
          <tbody v-if="!isLoansListEmpty">
            <borrower-loan-item
              v-for="item of archivedLoansList"
              :key="item.id"
              :item="item"
              @openPayModal="openPayModal"
            />
          </tbody>
        </table>
        <div v-if="isLoansListEmpty" class="empty-loans">{{ $t('message.profile.borrower.activeOffers.emptyArchiveLoans') }}</div>
      </div>
      <div class="loans-mobile-container">
        <mobile-borrower-loan-item
          v-for="item of archivedLoansList"
          :key="item.id"
          :item="item"
        />
        <div class="empty-loans" v-if="isLoansListEmpty">{{ $t('message.profile.borrower.activeOffers.emptyArchiveLoans') }}</div>
      </div>
      <div class="table-footer">
        <div class="notice">* - без учёта комиссий</div>
        <div v-if="loansPagesCounter > 0" class="pagination-block">
          <pagination
            :prevButtonPlaceholder="'<'"
            :nextButtonPlaceholder="'>'"
            :current-page="loansParams.page"
            :pages-count="loansPagesCounter"
            :total-count="archivedLoansCount"
            :page-size="loansParams.size"
            @choice="setLoansPage"
          />
        </div>
      </div>
    </div>
    <base-modal
      v-if="isPayModalVisible"
      @close="closePayModal()"
    >
      <template #header>
        <div class="modal-header">
          <img @click.stop="closePayModal()" class="close-image" src="../../../public/custom/images/cross.svg" alt="Cross image">
        </div>
        <div class="modal-title">
          {{ $t('message.profile.borrower.activeOffers.payModal.title') }}
        </div>
        <div class="pay-input-block">
          <base-payment-input
            class="pay-input"
            :placeholder="$t('message.profile.borrower.activeOffers.payModal.placeholder')"
            :name="'loanPayConfirmation'"
            :validateRules="validateRules"
            v-model="payment.amount"
            :disabled="isPayBtnLoading"
          />
        </div>
        <div class="btn-block">
          <base-button
            :text="$t('message.profile.borrower.activeOffers.payModal.payBtn')"
            :disabled="isPayBtnDisabled"
            :is-loading="isPayBtnLoading"
            @click="startPayment()"
          />
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import borrowerLoanItem from '../Profile/borrowerLoanItem.vue';
import BaseModal from '../../components/base/BaseModal.vue';
import BaseButton from '../../components/base/BaseButton.vue';
import BasePaymentInput from '../../components/base/BasePaymentInput.vue';
import MobileBorrowerLoanItem from '../Profile/mobileBorrowerLoanItem.vue';
import Pagination from '../../components/common/Pagination.vue';
import BaseSelect from '../../components/base/BaseSelect.vue';
import BaseDatepicker from '../../components/base/BaseDatepicker.vue';

export default {
  name: 'BorrowerArchive',
  inject: ['$httpService'],
  components: {
    borrowerLoanItem,
    BaseModal,
    BaseButton,
    BasePaymentInput,
    MobileBorrowerLoanItem,
    Pagination,
    BaseSelect,
    BaseDatepicker
  },
  data() {
    return {
      isPayModalVisible: false,
      payment: {
        totalAmount: 0,
        amount: '',
        loan_public_id: ''
      },
      isPayBtnLoading: false,
      loansParams: {
        page: 0,
        size: 10
      },
      loansFilter: {
        full_name_lender: undefined,
        receipt_date: undefined,
        status: undefined
      },
      loansFilterStatus: '',
      loansFilterSelectKey: 0
    };
  },
  methods: {
    getLoansRequestParams() {
      return {
        ...this.loansParams,
        filter: this.loansFilter
      };
    },
    async fetchLoansList() {
      this.$store.dispatch('loading', true);

      try {
        await this.$store.dispatch('getLoansArchivedList', this.getLoansRequestParams());
      } finally {
        this.$store.dispatch('loading', false);
      }
    },
    async setLoansFilter() {
      this.loansParams.page = 0;
      await this.fetchLoansList();
    },
    async resetLoansFilter() {
      this.loansParams.page = 0;
      this.loansFilterStatus = '';
      this.loansFilterSelectKey += 1;
      this.loansFilter = {
        full_name_lender: undefined,
        receipt_date: undefined,
        status: undefined
      };
      await this.fetchLoansList();
    },
    async setLoansPage(page) {
      this.loansParams.page = page;
      await this.fetchLoansList();
    },
    openPayModal(data) {
      this.payment = { ...this.payment, ...data };
      this.isPayModalVisible = true;
    },
    closePayModal() {
      if (!this.isPayBtnLoading) {
        this.isPayModalVisible = false;
      }
    },
    async startPayment() {
      this.isPayBtnLoading = true;
      const fixedAmount = (parseFloat(this.payment.amount).toFixed(2));
      const amount = (fixedAmount * 100).toFixed(0);
      const loan_public_id = this.payment.loan_public_id;

      try {
        await this.$httpService.loan.loanPayment({ amount, loan_public_id });

        this.isPayBtnLoading = false;
        this.closePayModal();
        this.loansParams.page = 0;
        await this.fetchLoansList();
      } catch (error) {
        this.isPayBtnLoading = false;
        this.closePayModal();
      }
    }
  },
  computed: {
    ...mapGetters(['archivedLoansList', 'archivedLoansCount']),
    isLoansListEmpty() {
      return this.archivedLoansList.length === 0;
    },
    loansPagesCounter() {
      return Math.ceil(this.archivedLoansCount / this.loansParams.size);
    },
    validateRules() {
      return `loanPayConfirmation:${this.payment.totalAmount},10`;
    },
    isPayBtnDisabled() {
      const amountMinor = Number((parseFloat(this.payment.amount || 0) * 100).toFixed(0));
      return this.errors.items.length > 0 || amountMinor < 10 || this.isPayBtnLoading;
    }
  },
  watch: {
    loansFilterStatus(value) {
      if (value) {
        this.loansFilter.status = value;
      } else {
        this.loansFilter.status = undefined;
      }
    },
    'loansFilter.receipt_date'(value) {
      if (value && value[0] === null) {
        this.loansFilter.receipt_date = undefined;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.borrower-archive-container {
  @include base-page-container;

  flex-direction: column;
  color: #121212;
}

.active-offers-container {
  @include active-offers-container;
  @include borrower-loans-table;

  min-width: auto;
  overflow-x: auto;
}

.active-offers-title {
  @include active-offers-title;
}

.filters-block {
  width: 100%;
  min-height: 36px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 16px;

  .filter-block {
    width: 190px;
    height: 36px;

    ::v-deep .input-wrapper {
      margin-bottom: 0;
      height: 100%;
    }

    ::v-deep .select-block {
      height: 36px;
    }

    ::v-deep .error-block {
      display: none;
    }
  }

  .button-block {
    width: 125px;
    height: 36px;
    margin-top: 0;

    ::v-deep .button {
      min-height: 36px;
      max-height: 36px;
      height: 36px;
      padding: 0 12px;
      border-radius: 6px;
    }
  }

  .reset-filter-btn {
    @include secondary-btn;
  }

  .datepicker-block {
    width: 230px;
    height: 36px;

    ::v-deep .mx-datepicker {
      width: 100%;
      height: 36px;
    }

    ::v-deep .mx-input-wrapper {
      height: 36px;
    }

    ::v-deep .mx-input {
      height: 36px;
    }
  }

  .filter-input {
    padding: 0 10px;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #CDCDCD;
    outline: none;

    &:active {
      border: 1px solid #DCDCDC;
    }
  }
}

.route-name {
  @include route-name;
}

.table-footer {
  margin-top: 15px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pagination-block {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
}

.notice {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #333333;
}

.empty-loans {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  box-sizing: border-box;
}

.loans-mobile-container {
  display: none;
  flex-direction: column;
}

.modal-header {
  @include modal-close-block;
}

.close-image {
  cursor: pointer;
}

.modal-title {
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #101010;
}

.pay-input-block {
  margin-bottom: 30px;
  width: 275px;
  height: 60px;
}

.pay-input ::v-deep {
  input,
  input::placeholder {
    text-align: center;
  }
}

.btn-block {
  margin-bottom: 35px;
  width: 275px;
  height: 60px;
}

@media screen and (max-width: 850px) {
  .loans-container .filters-block {
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 12px;

    .filter-block,
    .datepicker-block,
    .button-block {
      width: 100%;
    }

    .button-block ::v-deep .button {
      width: 100%;
      max-width: 100%;
    }
  }

  .loans-desktop-container {
    display: none;
  }

  .loans-mobile-container {
    display: flex;
  }
}
</style>
